import { useEffect, useState } from "react";
import api from "../lib/api";

const COLORS = { pending: "#FF7A00", approved: "#22C55E", rejected: "#FF2A5F" };

export default function MyPayments({ kind, refreshKey }) {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/payments/my").then(r => setRows(r.data || [])).catch(() => {}); }, [refreshKey]);
  const list = kind ? rows.filter(r => r.kind === kind) : rows;
  if (!list.length) return null;
  return (
    <div className="mt-6" data-testid="my-payments">
      <h2 className="font-outfit font-bold text-lg mb-2">My Payment Requests</h2>
      <div className="space-y-2">
        {list.slice(0, 10).map(p => (
          <div key={p.id} className="p-3 rounded-2xl bg-white/5 border border-white/10 text-xs flex items-center gap-3" data-testid={`my-payment-${p.id}`}>
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-sm truncate">{p.title}</div>
              <div className="text-white/50">₹{p.amount_inr.toLocaleString("en-IN")} · UTR {p.utr} · {new Date(p.created_at).toLocaleDateString()}</div>
              {p.reject_reason && <div className="text-[#FF2A5F]">{p.reject_reason}</div>}
            </div>
            <span className="px-2 py-0.5 rounded-full text-[10px] font-bold uppercase" style={{ color: COLORS[p.status], background: COLORS[p.status] + "22" }}>{p.status}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
